/**
 * Quick link functionality for product tabs
 * Extends anchor elements to automatically open corresponding collapsible tabs
 * Used for direct navigation to specific product tab sections
 */

if (!customElements.get('quick-link')) {
  class QuickLink extends HTMLAnchorElement {
    constructor() {
      super();

      this.addEventListener('click', function (e) {
        this.openCorrespondingTab();
      });
    }

    openCorrespondingTab() {
      const { hash } = this
      const correspondingTab = document.getElementById(hash.substring(1));
      const collapsibleGroup = correspondingTab.querySelector('.product-tab__collapsible');
      const isOpen = collapsibleGroup.classList.contains('collapsible-is-open') ? true : false;

      // Open corresponding collapsible
      (collapsibleGroup && !isOpen) && collapsibleGroup.classList.add('collapsible-is-open');
    }
  }

  customElements.define('quick-link', QuickLink, { extends: 'a' });
}